import { useState } from "react";
import Accordion from "./Accordion";

## Basic (Single Selection)

<Accordion.Root type="single" defaultValue="item-1" collapsible>
  <Accordion.Item value="item-1" header="Is it accessible?">
    <Accordion.Content>
      Yes. It adheres to the WAI-ARIA design pattern and provides full keyboard navigation.
    </Accordion.Content>
  </Accordion.Item>
  <Accordion.Item value="item-2" header="Is it unstyled?">
    <Accordion.Content>Yes. It's unstyled by default, giving you freedom over the look and feel.</Accordion.Content>
  </Accordion.Item>
  <Accordion.Item value="item-3" header="Can it be animated?">
    <Accordion.Content>Yes! You can animate the Accordion with CSS or JavaScript.</Accordion.Content>
  </Accordion.Item>
</Accordion.Root>

---

## Controlled

export function ControlledAccordion() {
  const [value, setValue] = useState("item-2");
  return (
    <div>
      <Accordion.Root type="single" value={value} onValueChange={setValue} collapsible>
        <Accordion.Item value="item-1" header="Getting Started">
          <Accordion.Content>Welcome! This section contains getting started info.</Accordion.Content>
        </Accordion.Item>
        <Accordion.Item value="item-2" header="User Guide">
          <Accordion.Content>Comprehensive guide to all features.</Accordion.Content>
        </Accordion.Item>
        <Accordion.Item value="item-3" header="API Reference">
          <Accordion.Content>Complete API documentation with examples.</Accordion.Content>
        </Accordion.Item>
      </Accordion.Root>
      <p>Current value: **{value || "none"}**</p>
    </div>
  );
}

<ControlledAccordion />

---

## Multiple Selection

export function MultipleAccordion() {
  const [values, setValues] = useState(["faq-1"]);
  return (
    <div>
      <Accordion.Root type="multiple" value={values} onValueChange={setValues}>
        <Accordion.Item value="faq-1" header="What is your return policy?">
          <Accordion.Content>30-day return policy for unused items.</Accordion.Content>
        </Accordion.Item>
        <Accordion.Item value="faq-2" header="How do I track my order?">
          <Accordion.Content>Use the tracking number sent to your email.</Accordion.Content>
        </Accordion.Item>
        <Accordion.Item value="faq-3" header="International shipping?">
          <Accordion.Content>Yes, we ship to over 50 countries.</Accordion.Content>
        </Accordion.Item>
      </Accordion.Root>
      <p>Open items: **{values.join(", ") || "none"}**</p>
    </div>
  );
}

<MultipleAccordion />

---

## Disabled

### Entire Accordion Disabled

<Accordion.Root type="single" disabled defaultValue="item-1">
  <Accordion.Item value="item-1" header="Disabled Item 1">
    <Accordion.Content>This content cannot be toggled.</Accordion.Content>
  </Accordion.Item>
  <Accordion.Item value="item-2" header="Disabled Item 2">
    <Accordion.Content>Also not interactive.</Accordion.Content>
  </Accordion.Item>
</Accordion.Root>

### Individual Item Disabled

<Accordion.Root type="single" defaultValue="item-1" collapsible>
  <Accordion.Item value="item-1" header="Active Item">
    <Accordion.Content>This item works normally.</Accordion.Content>
  </Accordion.Item>
  <Accordion.Item value="item-2" header="Disabled Item" disabled>
    <Accordion.Content>This specific item is disabled.</Accordion.Content>
  </Accordion.Item>
</Accordion.Root>
